import React from "react";
import { Dialog, DialogActions, Typography } from "@mui/material";
import { HDDialogContent, HDDialogTitle } from "ui-component/confirm-dialog/HDDialog";
import HDButtonsRow from "ui-component/widgets/buttons/hdButtons/HDButtonsRow";
import HDCancelButton from "ui-component/widgets/buttons/hdButtons/HDCancelButton";
import HDCommandButton from "ui-component/widgets/buttons/hdButtons/HDCommandButton";



const HDConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = "Continue",
  cancelButtonText = "Cancel",
  loading = false,
  maxWidth = "sm",
  fullWidth = true,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <HDDialogTitle>{title}</HDDialogTitle>

      <HDDialogContent>
        <Typography variant="hdDialogMsg">{message}</Typography>

        {children}
      </HDDialogContent>

      <DialogActions>
        <HDButtonsRow
          leftButtons={[
            <HDCancelButton
              key="cancel"
              buttonName={cancelButtonText}
              disableCancel={loading}
              onHandleCancel={onClose}
            />,
          ]}
          rightButtons={[
            <HDCommandButton
              key="confirm"
              commandButtonName={confirmButtonText}
              disableDelete={loading}
              onHandleCommand={onConfirm}
            />,
          ]}
        />
      </DialogActions>
    </Dialog>
  );
};

export default HDConfirmationDialog;